// ABOUTME: Mock data for TechLog → Rusada trip updates transformation testing.
import type { TechLogToRusadaTripUpdateInput } from './validation';

export const mockData: TechLogToRusadaTripUpdateInput = {
  techlog: {
    tripUpdate: {
      id: 'TU-2024-001',
      aircraftId: 'TL-AC-ZM335',
      date: '2024-01-20',
      number: 1,
      srpNumber: 1,
      customData: {},
      utilisation: {
        airframe_seconds: 3600,
        airframe_cycles: 1,
        airframe_landings: 1,
        airframe_flights: 0,
        engine_1_cycles: 1,
        engine_2_cycles: 1,
        engine_1_seconds: 3600,
        engine_2_seconds: 3600,
        apu_seconds: 600,
        apu_cycles: 1,
      },
      carriedForwardsOverride: {},
      broughtForwardsOverride: {},
      createdAt: '2024-01-20T06:00:00Z',
      updatedAt: '2024-01-20T07:30:00Z',
    },
    aircraft: {
      id: 'TL-AC-ZM335',
      registration: 'ZM335',
      serialNumber: '12345',
      aircraftTypeId: 'TL-AT-001',
      operatorId: 'TL-OP001',
      year: 2010,
      fuelUnit: 'kg',
      oilUnit: 'ml',
      maxFuelValue: 5000,
      monthlyCycles: 50,
      monthlyFlightSeconds: 180000,
      monthlyApuSeconds: 3600,
      maintenanceType: 'hours',
      apuMode: 'installed',
      flightStatus: 'onGround',
      createdAt: '2024-01-01T00:00:00Z',
      updatedAt: '2024-01-20T07:30:00Z',
      aircraftType: {
        id: 'TL-AT-001',
        engineType: 'turboprop',
        engineCount: '2',
        weightCategory: 'medium',
      },
    },
  },
  rusada: {
    registration: {
      id: 5,
      assetId: 3,
      registration: 'ZM335',
      statusId: 1,
      status: 'ACTIVE',
      serialNo: '12345',
      operator: 'Affinity Flight Training Services',
      isLocked: false,
    },
    defaultPlaceId: 5634,
    techLogCategories: [
      {
        id: 1,
        category: 'Tech Log',
        isTechLog: true,
        isMaintenanceEntry: false,
        isCabinLog: false,
      },
      {
        id: 2,
        category: 'Maintenance',
        isTechLog: false,
        isMaintenanceEntry: true,
        isCabinLog: false,
      },
    ],
    flightTypes: [
      {
        id: 6,
        type: 'EGR',
        description: 'Engine Ground Run',
        positioningFlight: false,
        trainingFlight: false,
        newJourneyDefault: false,
      },
      {
        id: 15,
        type: 'Not Flown',
        description: 'Not Flown',
        positioningFlight: false,
        trainingFlight: false,
        newJourneyDefault: false,
      },
    ],
  },
};
